import { useLoadLookup } from 'components/common/FilterArea/Filters/useLoadLookup';
import { CodeNameModel } from 'components/common/types';
import { InputShape, InputSize, InputTheme } from 'components/common/types/Input.types';
import { Store } from 'components/common/types/Store.types';
import useIsReadOnly from 'components/pages/Planner/useIsReadOnly';
import { ShadowStyle } from 'consts/shadow';
import AsyncSelect from 'lib/AsyncSelect';
import { Padding } from 'lib/BaseSelect/BaseSelect.types';
import { Label } from 'lib/Label';
import { useDispatch, useSelector } from 'react-redux';
import { changeDealData } from 'store/dealManagement/reducer';
import { isRequiredDirectSalesField } from 'utils/isRequiredDirectSalesField';
import Tooltip, { TooltipDirection } from 'lib/Tooltip';

interface SelectAdminPersonProps {
  isDisabled?: boolean;
}

const SelectAdminPerson: React.FC<SelectAdminPersonProps> = ({ isDisabled }) => {
  const dispatch = useDispatch();

  const adminPerson = useSelector((state: Store) => state.dealManagement.commonDeal.adminPerson);
  const directSalesRequiredFieldsConfig = useSelector((state: Store) => state.publisher.directSalesRequiredFields);
  const isRequired = isRequiredDirectSalesField({
    fieldsConfig: directSalesRequiredFieldsConfig,
    fieldName: 'adminPerson',
  });

  const { onLoadAdminPerson } = useLoadLookup();

  const { isCampaignReadOnly } = useIsReadOnly();

  const handleSelectAdminPerson = (key: string, value: CodeNameModel): void => {
    dispatch(changeDealData({ [key]: value }));
  };

  return (
    <>
      <Label id="adminPerson" theme={InputTheme.FLAT_GRAY} label="Admin person" isRequired={isRequired} />
      <Tooltip tooltip={adminPerson?.name} direction={TooltipDirection.BOTTOM} isHiddenOnFocus>
        <AsyncSelect
          name="adminPerson"
          dataTestId="async-select-adminPerson"
          placeholder=""
          theme={InputTheme.WHITE_WITH_BORDER}
          size={InputSize.EXTRA_SMALL}
          padding={Padding.NONE}
          shadow={ShadowStyle.NONE}
          shape={InputShape.ROUNDED}
          selectedValue={adminPerson}
          loadData={onLoadAdminPerson}
          onSelect={handleSelectAdminPerson}
          isDisabled={isDisabled || isCampaignReadOnly}
        />
      </Tooltip>
    </>
  );
};

export default SelectAdminPerson;
